export const RESOURCES_DEFAULT_AVATAR_WIDTH = '?w=96'
